<template>
  <page-header-wrapper>
    <a-card>
      <div>
        <div style="padding: 5px">
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="queryParam.dateRange"  @change="dateChange" />
          <div class="two" style="position: absolute; top: 30px; left: 450px" >
            <span :class="isOrderSelect === 'day'?'isActive': ''" @click="handelOrderClick('day')">当天</span>
            <span :class="isOrderSelect === 'week'?'isActive': ''" @click="handelOrderClick('week')">本周</span>
            <span :class="isOrderSelect === 'month'?'isActive': ''" @click="handelOrderClick('month')">本月</span>
            <span :class="isOrderSelect === 'quarter'?'isActive': ''" @click="handelOrderClick('quarter')">本季度</span>
            <span :class="isOrderSelect === 'year'?'isActive': ''" @click="handelOrderClick('year')" style="margin-right:10px;">本年</span>
          </div>
        </div>
        <a-row>
          <a-col :span="8" style="background: rgb(0, 0, 255, 0.1); padding: 20px">
            <div class="grid-content bg-purple">
              <div class="left" >
                <a-icon type="money-collect" style="font-size: 2.5rem;color: blue"/>
              </div>
              <div class="left">
                <p class="title">保证金</p>
                <p class="title color margin-b-10">¥ {{ (dataList.marginAmount) }}</p>
              </div>
            </div>
          </a-col>
          <a-col :span="8" style="background: rgb(34, 139, 34, 0.1); margin: 0 14px; padding: 20px">
            <div class="grid-content bg-purple-light">
              <div class="left ">
                <a-icon type="money-collect" style="font-size: 2.5rem;color: red"/>
              </div>
              <div class="left">
                <p class="title">平台抽成总和</p>
                <p class="title color margin-b-10">¥ {{ (dataList.platformRateAmount) }}</p>
              </div>
            </div>
          </a-col>
          <a-col :span="7" style="background: rgb(0, 0, 255, 0.1); padding: 20px;margin-right: 10px;">
            <div class="grid-content bg-purple">
              <div class="left cornflowerblue">
                <a-icon type="money-collect" style="font-size: 2.5rem;color: green"/>
              </div>
              <div class="left">
                <p class="title">订单量</p>
                <p class="title color margin-b-10"> {{ (dataList.orderCount) }}</p>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row style="margin-top: 20px">
          <a-col :span="6" style="background: rgb(106, 90, 205, 0.1); padding: 20px">
            <div class="grid-content bg-purple" @click.prevent="handleLink('/order/order')">
              <div class="left cornflowerblue">
                <a-icon type="account-book" style="font-size: 2.5rem;color: deepskyblue"/>
              </div>
              <div class="left">
                <p class="title">销售额</p>
                <p class="title color margin-b-10">¥{{ dataList.payAmount }}</p>
              </div>
            </div>
          </a-col>
          <a-col :span="6" style="background: rgb(0, 0, 255, 0.1); margin: 0 10px; padding: 20px">
            <div class="grid-content bg-purple-light" @click.prevent="handleLink('/order/refund')">
              <div class="left cornflowerblue">
                <a-icon type="account-book" style="font-size: 2.5rem;color: red"/>
              </div>
              <div class="left">
                <p class="title">充值总额</p>
                <p class="title color margin-b-10">¥{{ dataList.rechargeAmount || 0 }}</p>
              </div>
            </div>
          </a-col>
          <a-col :span="5" style="background: rgb(138, 43, 266, 0.1); margin: 0 10px;  padding: 20px">
            <div class="grid-content bg-purple" @click.prevent="handleLink('/user/tbUser')">
              <div class="left cornflowerblue">
                <a-icon type="user-add" style="font-size: 2.5rem;color: #bae7ff"/>
              </div>
              <div class="left">
                <p class="title">店铺总数</p>
                <p class="title color margin-b-10">{{ dataList.merchantCount || 0 }}</p>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row style="margin-top: 20px">
          <a-col :span="7" style="background: rgb(255, 192, 203, 0.1); padding: 20px">
            <div class="grid-content bg-purple">
              <div class="left cornflowerblue">
                <a-icon type="user-add" style="font-size: 2.5rem;color: red"/>
              </div>
              <div class="left">
                <p class="title">新增用户</p>
                <p class="title color margin-b-10"> {{ (dataList.userCount) }}</p>
                <!-- <p class="title color">¥ 200</p> -->
              </div>
            </div>
          </a-col>
        </a-row>

      </div>

    </a-card>

    <a-card title="RFM 客户分群统计" style="margin-top: 16px">
      <a-table
        :columns="rfmColumns"
        :data-source="rfmList"
        :pagination="false"
        :loading="rfmLoading"
        row-key="rfmGroup"
        size="middle"
        :row-class-name="rfmRowClassName"
      >
        <span slot="percentOfCustomers" slot-scope="text">
          {{ text != null ? text + '%' : '-' }}
        </span>
        <span slot="totalAmountSpent" slot-scope="text">
          {{ text != null ? '¥ ' + Number(text).toLocaleString() : '-' }}
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {timeFix} from '@/utils/util'
import * as echarts from 'echarts'
import {mapGetters} from 'vuex'
import moment from 'moment';
import {PageHeaderWrapper} from '@/components/ProLayout'
import {getUserProfile} from '@/api/system/user'
import {homePlatResult} from '@/api/statistics/home'
import {getRfmGroupStatistics} from '@/api/statistics/order'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper
  },
  data() {
    return {
      dataList: {
      }, //首页看板
      rfmList: [],
      rfmLoading: false,
      rfmColumns: [
        { title: 'RFM group', dataIndex: 'rfmGroup', key: 'rfmGroup', width: 140 },
        { title: 'Percent of customers', dataIndex: 'percentOfCustomers', key: 'percentOfCustomers', width: 160, scopedSlots: { customRender: 'percentOfCustomers' } },
        { title: 'New customer records', dataIndex: 'newCustomerRecords', key: 'newCustomerRecords', width: 160, align: 'right' },
        { title: 'Days since last order', dataIndex: 'daysSinceLastOrder', key: 'daysSinceLastOrder', width: 160, align: 'right' },
        { title: 'Total number of orders', dataIndex: 'totalNumberOfOrders', key: 'totalNumberOfOrders', width: 180, align: 'right' },
        { title: 'Total amount spent', dataIndex: 'totalAmountSpent', key: 'totalAmountSpent', width: 160, scopedSlots: { customRender: 'totalAmountSpent' } }
      ],
      advert: {}, //广告
      goodsShare: {}, //商品
      timeFix: timeFix(),
      // 用户信息
      user: {
        dept: {
          deptName: ''
        }
      },

      queryParam: {
        chartType: 'day',
        dateRange: [],
        startTime: undefined,
        endTime:undefined,
      },
      /*销售数据选择*/
      isOrderSelect: 'day',
      roleGroup: {},
      postGroup: {},
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ])
  },
  created() {
    this.getUser()
    this.handelOrderClick('month')
  },
  mounted() {

  },
  methods: {
    handelOrderClick(val) {
      this.isOrderSelect = val;
      this.queryParam.chartType = val;
      let startDate, endDate;
      switch (val) {
        case 'week': // 本周
          startDate = moment().startOf('week').add(1, 'day'); // 周一作为起始
          endDate = moment().endOf('week').add(1, 'day');     // 周日作为结束
          break;
        default:
          startDate = moment().startOf(val);
          endDate = moment().endOf(val);
      }

      // 设置日期控件显示值

      // 设置 startTime 和 endTime 查询参数
      this.queryParam.startTime = startDate.format('YYYY-MM-DD HH:mm:ss');
      this.queryParam.endTime = endDate.format('YYYY-MM-DD HH:mm:ss');
      let dateRange = []
      dateRange.push(startDate.format('YYYY-MM-DD'))
      dateRange.push(endDate.format('YYYY-MM-DD'))
      this.queryParam.dateRange = dateRange
      this.getHomeStatistics()
    },
    dateChange(val) {
      this.queryParam.startTime = val[0] + ' 00:00:00';
      this.queryParam.endTime = val[1]+ ' 23:59:59';
      this.getHomeStatistics()
    },
    // 获取用户信息
    getUser() {
      getUserProfile().then(response => {
        this.user = response.data
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    getHomeStatistics() {
      homePlatResult(this.queryParam).then(response => {
        this.dataList = response.data
      })
      this.getRfmStatistics()
    },
    getRfmStatistics() {
      this.rfmLoading = true
      getRfmGroupStatistics(this.queryParam).then(response => {
        this.rfmList = response.data || []
      }).finally(() => {
        this.rfmLoading = false
      })
    },
    rfmRowClassName(record) {
      return record && record.rfmGroup === 'Summary' ? 'rfm-summary-row' : ''
    },
  }
}
</script>

<style lang="less" scoped>

blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
}

.project-list {

  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 66px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .download {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.mobile {

  .project-list {

    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}

.home {
  blockquote {
    padding: 10px 20px;
    margin: 0 0 20px;
    font-size: 17.5px;
    border-left: 5px solid #eee;
  }

  hr {
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eee;
  }

  .col-item {
    margin-bottom: 20px;
  }

  ul {
    padding: 0;
    margin: 0;
  }

  font-family: "open sans",
  "Helvetica Neue",
  Helvetica,
  Arial,
  sans-serif;
  font-size: 13px;
  color: #676a6c;
  overflow-x: hidden;

  ul {
    list-style-type: none;
  }

  h4 {
    margin-top: 0px;
  }

  h2 {
    margin-top: 10px;
    font-size: 26px;
    font-weight: 100;
  }

  p {
    margin-top: 10px;

    b {
      font-weight: 700;
    }
  }

  .update-log {
    ol {
      display: block;
      list-style-type: decimal;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0;
      margin-inline-end: 0;
      padding-inline-start: 40px;
    }
  }
}

.left {
  float: left;
}

.right {
  float: right;
}

.cleafix {
  clear: both;
  overflow: hidden;
  content: '';
}

::v-deep .el-icon-s-custom:before {
  font-size: 30px;
}

.cornflowerblue {
  border-radius: 100%;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  margin-right: 10px;
}

::v-deep .el-table th {
  background: rgba(3, 146, 240, 1);
  color: #fff;
}

::v-deep .el-table .warning-row {
  background: rgb(169, 109, 205, 0.1);
}

::v-deep .el-table .success-row {
  background: rgba(108, 182, 201, 0.1);
}

::v-deep .el-table__body-wrapper {
  height: 324px;
  overflow-y: auto;
}

.two1 {
  // margin-left: 125px;
  margin-bottom: 20px;

  span {
    display: inline-block;
    line-height: 40px;
    width: 60px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #999999;
    // color: #1890ff;
  }

  span:nth-child(1) {
    border-radius: 6px 0 0 6px;
    border-right: none;

  }

  span:nth-child(2) {
    border-radius: 0;
    border-right: none;

  }

  span:nth-child(3) {
    border-radius: 0;
    border-right: none;

  }

  span:nth-child(4) {
    border-radius: 0 6px 6px 0;
    position: relative;
  }

  span:nth-child(4) .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
  }
}

.two {
  margin-left: 10px;
  margin-right: 125px;

  span {
    display: inline-block;
    line-height: 30px;
    width: 60px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #999999;
    // color: #1890ff;
  }

  span:nth-child(1) {
    border-radius: 6px 0 0 6px;
    border-right: none;

  }

  span:nth-child(2) {
    border-radius: 0;
    border-right: none;

  }

  span:nth-child(3) {
    border-radius: 0;
    border-right: none;

  }

  span:nth-child(4) {
    border-radius: 0 6px 6px 0;
    position: relative;
  }

  span:nth-child(4) .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
  }
}

.isActive {
  background: #1890ff;
  color: #ffffff !important;
  border: 1px solid #1890ff !important;

  // color: #fff;
}

::v-deep .el-range-input {
  // width: 84px;
}

::v-deep .el-input__inner {
  // width: auto !important;
}

.title {
  font-weight: bold;
  font-size: 16px;
}

.color {
  color: red;
  font-size: 18px;
}

.margin-b-10 {
  margin-bottom: 10px !important;
}
.cleafix {
  clear: both;
  overflow: hidden;
  content: '';
}

::v-deep .rfm-summary-row {
  background: rgba(0, 0, 0, 0.04);
  font-weight: 500;
}
</style>
